import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { componentIcon } from "../../data/options";

export const ComponentList = ({ items, light = false, testid }) => (
  <ul className="space-y-3" data-testid={testid}>
    {items.map((c) => {
      const I = componentIcon(c);
      return (
        <li key={c} className="flex items-center gap-3">
          <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${light ? "bg-[#FFFDFB]/15 text-[#FFFDFB]" : "bg-[#650D23]/10 text-[#650D23]"}`}>
            <I className="h-4 w-4" />
          </span>
          <span className="text-[.95rem]">{c}</span>
        </li>
      );
    })}
  </ul>
);

export const ForfaitMiniCard = ({ f, featured = false }) => (
  <article className={`flex h-full flex-col rounded-2xl border p-7 transition-transform duration-300 hover:-translate-y-1 ${featured ? "border-[#4A0C1B] bg-[#650D23] text-[#FFFDFB]" : "card-soft"}`}
    data-testid={`forfait-card-${f.slug}`}>
    <h3 className="text-center text-xl uppercase tracking-wide">{f.name}</h3>
    <p className={`mt-3 text-center text-sm ${featured ? "text-[#EDE3D9]" : "text-[#242020]/70"}`}>{f.tagline}</p>
    <div className="my-6 flex-1"><ComponentList items={f.components} light={featured} /></div>
    <Link to={`/forfaits/${f.slug}`} data-testid={`forfait-card-${f.slug}-link`} className={featured ? "btn-light justify-center" : "btn-outline"}>
      En savoir plus <ArrowRight className="h-4 w-4" />
    </Link>
  </article>
);
